module.exports = __webpack_public_path__ + "media/images/common/cart-8e26e1bdd22004597bff75005496535f.png";